var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12H12V19H19V12ZM18 13H13V18H18V13Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 12H20V19H27V12ZM26 13H21V18H26V13Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 12H28V19H35V12ZM34 13H29V18H34V13Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 20H12V27H19V20ZM18 21H13V26H18V21Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 20H20V27H27V20ZM26 21H21V26H26V21Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 20H28V27H35V20ZM34 21H29V26H34V21Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 28H12V35H19V28ZM18 29H13V34H18V29Z",
    fill: "#414042"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 28H20V35H27V28ZM26 29H21V34H26V29Z",
    fill: "#414042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 28H28V35H35V28ZM34 29H29V34H34V29Z",
    fill: "#414042"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14H18V18H13V14Z",
    fill: "#414042"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17H26V18H21V17Z",
    fill: "#414042"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24H18V26H13V24Z",
    fill: "#414042"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23H26V26H21V23Z",
    fill: "#414042"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29H34V34H29V29Z",
    fill: "#414042"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30H26V34H21V30Z",
    fill: "#414042"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13 33H18V34H13V33Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/Screen.e0d775980ab9a5faeb1bf35fee0b6caa.svg";
export { ForwardRef as ReactComponent };